import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import IconSprite from './views/IconSprite'
import Home from './views/Home'
import Dorms from './views/Dorms'
import PersonDetail from './views/PersonDetail'
import MovieDetail from './views/MovieDetail'
import DormSearch from './views/DormSearch'
import ActorSearch from './views/ActorSearch'
import NetworkSearch from './views/NetworkSearch'
import Network from './views/Network/Network'
import NetworkMain from './views/Network/NetworkMain'
import Person from './views/Person/Person'
import PersonMain from './views/Person/PersonMain'
import PersonGender from './views/Person/PersonGender'
import PersonDistinct from './views/Person/PersonDistinct'
import PersonDistinctGender from './views/Person/PersonDistinctGender'
import CityList from './views/CityList'
import City from './views/City/City'
import CityMain from './views/City/CityMain'
import CityGender from './views/City/CityGender'
import CityDistrict from './views/City/CityDistrict'
import CityDistrictGender from './views/City/CityDistrictGender'
import Studio from './views/Studio/Studio'
import StudioMain from './views/Studio/StudioMain'
import StudioGenre from './views/Studio/StudioGenre'
import StudioProduct from './views/Studio/StudioProduct'
import StudioProductGenre from './views/Studio/StudioProductGenre'
import UniSearch from './views/UniSearch'
import UniDetail from './views/UniDetail'
import UniDetailFaculty from './views/UniDetailFaculty'
import UniDetailAbout from './views/UniDetailAbout'
import UniDetailCampus from './views/UniDetailCampus'
import UniQuestionsAnswer from './views/UniQuestionsAnswer'
import Blog from './views/Blog'
import BlogDetail from './views/BlogDetail'
import BlogCategory from './views/BlogCategory'
import CityDetail from './views/CityDetail/CityDetail'
import CityDetailAbout from './views/CityDetail/CityDetailAbout'
import CityDetailDistrict from './views/CityDetail/CityDetailDistrict'
import CityDetailUnivercities from './views/CityDetail/CityDetailUnivercities'
import About from './views/About'
import Notice from './views/Notice'
import Login from './views/Login'
import Register from './views/Register'
import User from './views/User'
import UserComment from './views/UserComment'
import UserSettings from './views/UserSettings'
import UserOffers from './views/UserOffers'
import UserFavorites from './views/UserFavorites'
import UserRatedMovies from './views/UserRatedMovies'
import UserWatchlist from './views/UserWatchlist'
import DormUser from './views/DormUser'
import DormUserAccount from './views/DormUserAccount'
import DormUserMessages from './views/DormUserMessages'
import DormUserMessageDetail from './views/DormUserMessageDetail'
import DormUserDorms from './views/DormUserDorms'
import DormUserDormDetail from './views/DormUserDormDetail'
import DormUserDormUpdate from './views/DormUserDormUpdate'
import DormUserStatistic from './views/DormUserStatistic'
import DormUserComments from './views/DormUserComments'
import Faq from './views/Faq'
import Contact from './views/Contact'
import Advertisement from './views/Advertisement'
import UserContract from './views/UserContract'
import SalesContract from './views/SalesContract'
import CancelPolicy from './views/CancelPolicy'
import RegisterDorm from './views/RegisterDorm'
import ForgetPassword from './views/ForgetPassword'
import PrivacyPolicy from './views/PrivacyPolicy'
import LoginDorm from './views/LoginDorm'
import Media from './views/Media'
import CitySearchResult from './views/CitySearchResult'
import ErrorPage404 from './views/ErrorPage404'
import SmartMap from './views/SmartMap'
import SeriesSearch from './views/SeriesSearch'
import Branch from './views/Branch/Branch'
import BranchMain from './views/Branch/BranchMain'
import BranchGender from './views/Branch/BranchGender'
import BranchDistrict from './views/Branch/BranchDistrict'
import BranchDistrictGender from './views/Branch/BranchDistrictGender'
import RequestPrice from './views/RequestPrice'

// import VueBreadcrumbs from 'vue-breadcrumbs'

// Vue.use(VueBreadcrumbs)
Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { pageClass: 'home', breadcrumb: 'HolywoodSkyline' }
    },
    {
      path: '/icon-sprite',
      name: 'IconSprite',
      component: IconSprite
    },
    {
      path: '/movies',
      name: 'Dorms',
      component: Dorms,
      meta: { pageClass: 'subpage subpage-gray dorm', breadcrumb: 'Movies' }
    },
    {
      path: '/genres',
      name: 'CityList',
      component: CityList,
      meta: { pageClass: 'subpage subpage-gray city-list', breadcrumb: 'Şehirler' }
    },
    {
      path: '/:slug-movies/',
      // name: 'Studio',
      component: Studio,
      meta: { pageClass: 'subpage city' },
      children: [
        {
          path: '',
          name: 'Studio',
          component: StudioMain,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'Movies' }
            ]
          }
        },
        {
          path: ':page',
          name: 'StudioPage',
          component: StudioMain,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'Studio' }
            ]
          }
        },
        {
          path: '/:slug--:genre/', // removed :faculty
          name: 'StudioProduct',
          component: StudioProduct,
          meta: { pageClass: 'subpage city', breadcrumb: 'Studio Movies' }
        },
        {
          path: '/:slug--:faculty--:type-shows/',
          name: 'StudioProductGenre',
          component: StudioProductGenre,
          meta: { pageClass: 'subpage city', breadcrumb: 'Movies' }
        },
        {
          path: '/:slug-studios-:type-movies/',
          name: 'StudioGenre',
          component: StudioGenre,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'Movies' }
            ]
          }
        }
      ]
    },
    {
      path: '/genres',
      name: 'CityList',
      component: CityList,
      meta: { pageClass: 'subpage subpage-gray city-list', breadcrumb: 'Genres' }
    },
    {
      path: '/:networks/',
      // name: 'Studio',
      component: Network,
      meta: { pageClass: 'subpage city' },
      children: [
        {
          path: '/:network-network',
          name: 'Network',
          component: NetworkMain,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'Episodes' }
            ]
          }
        },
      ]
    },    
    {
      path: '/celebrities/', // :person-celebrities
      // name: 'City',
      component: Person,
      meta: { pageClass: 'subpage city' },
      children: [
        {
          path: '',
          name: 'Person',
          component: PersonMain,
          meta: {
            pageClass: 'subpage person',
            breadcrumb: [
              { name: 'Movies' }
            ]
          }
        },
        {
          path: '/:person-:distinct-celebrities1/',
          name: 'PersonDistinct',
          component: PersonDistinct,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'celebrities' }
            ]
          }
        },        
        {
          path: '/:person-:type-celebrities/',
          name: 'PersonGender',
          component: PersonGender,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'Movies' }
            ]
          }
        },
        {
          path: '/:city-:district-:type-celebrities2/',
          name: 'PersonDistincttGender',
          component: PersonDistinctGender,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'Movies' }
            ]
          }
        },               
      ]
    },    
    {
      path: '/:city-movies/',
      // name: 'City',
      component: City,
      meta: { pageClass: 'subpage city' },
      children: [
        {
          path: '',
          name: 'City',
          component: CityMain,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'Movies' }
            ]
          }
        },
        {
          path: ':page',
          name: 'CityPage',
          component: CityMain,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'CityPage' }
            ]
          }
        },
        {
          path: '/:city-:district-movies/',
          name: 'CityDistrict',
          component: CityDistrict,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'Subgenre movies' }
            ]
          }
        },
        {
          path: '/:city-:district-movies/:page',
          name: 'CityDistrictPage',
          component: CityDistrict,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'Subgenre movies' }
            ]
          }
        },
        {
          path: '/:city-:district-ilcesi-:type-movies/',
          name: 'CityDistrictGender',
          component: CityDistrictGender,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'Movies' }
            ]
          }
        },
        {
          path: '/:city-:gender-movies/',
          name: 'CityGender',
          component: CityGender,
          meta: {
            pageClass: 'subpage city',
            breadcrumb: [
              { name: 'Movies' }
            ]
          }
        }
      ]
    },
    {
      path: '/networks',
      name: 'NetworkSearch',
      component: NetworkSearch,
      meta: { pageClass: 'subpage subpage-gray uni-detail uni-search', breadcrumb: 'Networks' }
    },    
    {
      path: '/studios',
      name: 'UniSearch',
      component: UniSearch,
      meta: { pageClass: 'subpage subpage-gray uni-detail uni-search', breadcrumb: 'Studios' }
    },
    {
      path: '/actors',
      name: 'ActorSearch',
      component: ActorSearch,
      meta: { pageClass: 'subpage subpage-gray uni-detail uni-search', breadcrumb: 'Actors' }
    },    
    {
      path: '/blog',
      name: 'Blog',
      component: Blog,
      meta: {
        pageClass: 'subpage subpage-gray blog',
        breadcrumb: [
          { name: 'Blog' }
        ]
      }
    },
    {
      path: '/blog/:slug--:id',
      name: 'BlogDetail',
      component: BlogDetail,
      meta: {
        pageClass: 'subpage subpage-gray blog',
        breadcrumb: [
          { name: 'Blog' }
        ]
      }
    },
    {
      path: '/blog/kategori/:slug',
      name: 'BlogCategory',
      component: BlogCategory,
      meta: {
        pageClass: 'subpage-gray blog',
        breadcrumb: [
          { name: 'Blog Category' }
        ]
      }
    },
    {
      path: '/:city-sehri-hakkinda/',
      component: CityDetail,
      meta: { pageClass: 'subpage uni-detail', disableLoader: true },
      children: [
        {
          path: '',
          name: 'CityDetailAbout',
          component: CityDetailAbout,
          meta: {
            pageClass: 'subpage uni-detail',
            disableLoader: true
          }
        },
        {
          path: 'ilceler',
          name: 'CityDetailDistrict',
          component: CityDetailDistrict,
          meta: { pageClass: 'subpage uni-detail district', disableLoader: true }
        },
        {
          path: 'universiteler',
          name: 'CityDetailUnivercities',
          component: CityDetailUnivercities,
          meta: { pageClass: 'subpage uni-detail', disableLoader: true }
        }
      ]
    },
    {
      path: '/:slug-about',
      component: UniDetail,
      meta: { pageClass: 'subpage uni-detail' },
      children: [
        {
          path: '',
          name: 'UniDetailAbout',
          component: UniDetailAbout,
          meta: {
            pageClass: 'subpage uni-detail',
            disableLoader: true,
            breadcrumb: [
              { name: 'About Studio' }
            ]
          }
        },
        {
          path: 'campus',
          name: 'UniDetailCampus',
          component: UniDetailCampus,
          meta: { pageClass: 'subpage uni-detail', disableLoader: true }
        },
        {
          path: 'faculties',
          name: 'UniDetailFaculty',
          component: UniDetailFaculty,
          meta: { pageClass: 'subpage uni-detail', disableLoader: true }
        },
        {
          path: 'question-answer',
          name: 'UniQuestionsAnswer',
          component: UniQuestionsAnswer,
          meta: { pageClass: 'subpage questions-answer', disableLoader: true }
        }
      ]
    },
    {
      path: '/ads-for-movies',
      name: 'Notice',
      component: Notice,
      meta: { pageClass: 'subpage uni-detail notice' }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: { pageClass: 'subpage-gray about' }
    },
    {
      path: '/media',
      name: 'Media',
      component: Media,
      meta: { pageClass: 'subpage-gray about medias' }
    },
    {
      path: '/user-login',
      name: 'Login',
      component: Login,
      meta: { pageClass: 'subpage subpage-gray login' }
    },
    {
      path: '/admin-login',
      name: 'LoginDorm',
      component: LoginDorm,
      meta: { pageClass: 'subpage subpage-gray login' }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { pageClass: 'subpage subpage-gray login register' }
    },
    {
      path: '/user-management',
      component: User,
      meta: { pageClass: 'subpage subpage-gray user' },
      children: [
        {
          path: '',
          name: 'UserSettings',
          component: UserSettings,
          meta: { pageClass: 'subpage subpage-gray user' }
        },
        {
          path: 'comments',
          name: 'UserComment',
          component: UserComment,
          meta: { pageClass: 'subpage subpage-gray user' }
        },
        {
          path: 'teklifler',
          name: 'UserOffers',
          component: UserOffers,
          meta: { pageClass: 'subpage subpage-gray user' }
        },
        {
          path: 'favorites',
          name: 'UserFavorites',
          component: UserFavorites,
          meta: { pageClass: 'subpage subpage-gray user' }
        },
        {
          path: 'ratedmovies',
          name: 'UserRatedMovies',
          component: UserRatedMovies,
          meta: { pageClass: 'subpage subpage-gray user' }
        },
        {
          path: 'watchlist',
          name: 'UserWatchlist',
          component: UserWatchlist,
          meta: { pageClass: 'subpage subpage-gray user' }
        }         
      ]
    },
    {
      path: '/domain-management',
      component: DormUser,
      meta: { pageClass: 'subpage subpage-gray user' },
      children: [
        {
          path: 'account-informatin',
          name: 'DormUserAccount',
          component: DormUserAccount,
          meta: { pageClass: 'subpage uni-detail subpage-gray user' }
        },
        {
          path: 'messages',
          name: 'DormUserMessages',
          component: DormUserMessages,
          meta: { pageClass: 'subpage subpage-gray user' }
        },
        {
          path: 'messages/:id',
          name: 'DormUserMessageDetail',
          component: DormUserMessageDetail,
          meta: { pageClass: 'subpage subpage-gray user' }
        },
        {
          path: 'movies',
          name: 'DormUserDorms',
          component: DormUserDorms,
          meta: { pageClass: 'subpage subpage-gray user my-dorm' }
        },
        // {
        //   path: 'yurtlar/:id',
        //   name: 'DormUserDormDetail',
        //   component: DormUserDormDetail,
        //   meta: { pageClass: 'subpage subpage-gray user' }
        // },
        {
          path: 'statistics',
          name: 'DormUserStatistic',
          component: DormUserStatistic,
          meta: { pageClass: 'subpage uni-detail subpage-gray user' }
        },
        {
          path: 'comments',
          name: 'DormUserComments',
          component: DormUserComments,
          meta: { pageClass: 'subpage subpage-gray user uni-detail' }
        },
        {
          path: 'add',
          name: 'DormUserDormDetail',
          component: DormUserDormDetail,
          meta: {
            pageClass: 'subpage subpage-gray user account-dorm',
          }
        },
        {
          path: 'edit',
          name: 'DormUserDormUpdate',
          component: DormUserDormUpdate,
          meta: {
            pageClass: 'subpage subpage-gray user account-dorm',
          }
        }        
      ]
    },
    {
      path: '/frequently-asked-questions',
      name: 'Faq',
      component: Faq,
      meta: {
        pageClass: 'subpage subpage-gray questions',
        breadcrumb: [
          { name: 'Frequently Asked Questions' }
        ]
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        pageClass: 'subpage subpage-gray contact',
        breadcrumb: [
          { name: 'Contact' }
        ]
      }
    },
    {
      path: '/movie-search',
      name: 'DormSearch',
      component: DormSearch,
      meta: {
        pageClass: 'subpage uni-detail subpage-gray dorm-search',
        breadcrumb: [
          { name: 'Hollywood Movies', link: 'CityPage' }
        ]
      }
    },
    {
      path: '/smart-map',
      name: 'DormSearch',
      component: DormSearch,
      meta: {
        pageClass: 'subpage uni-detail subpage-gray dorm-search',
        breadcrumb: [
          { name: 'Smart Map' }
        ]
      }
    },
    {
      path: '/dvd-renting',
      name: 'RequestPrice',
      component: RequestPrice,
      meta: {
        pageClass: 'subpage uni-detail subpage-gray dorm-search request-price',
        breadcrumb: [
          { name: 'Akıllı Harita' }
        ]
      }
    },
    {
      path: '/add-movie',
      name: 'Advertisement',
      component: Advertisement,
      meta: {
        pageClass: 'subpage subpage-gray advertisement',
        breadcrumb: [
          { name: 'Add Advertisement' }
        ]
      }
    },
    {
      path: '/user-contract',
      name: 'UserContract',
      component: UserContract,
      meta: { pageClass: 'subpage uni-detail subpage-gray user-contract' }
    },
    {
      path: '/distance-sales-contract',
      name: 'SalesContract',
      component: SalesContract,
      meta: { pageClass: 'subpage uni-detail subpage-gray user-contract' }
    },
    {
      path: '/cancel-and-return-conditions',
      name: 'CancelPolicy',
      component: CancelPolicy,
      meta: { pageClass: 'subpage uni-detail subpage-gray user-contract' }
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
      meta: { pageClass: 'subpage uni-detail subpage-gray user-contract' }
    },
    {
      path: '/forget-password',
      name: 'ForgetPassword',
      component: ForgetPassword,
      meta: { pageClass: 'subpage uni-detail subpage-gray forget' }
    },
    /*     {
      path: '/yurt-kayit',
      name: 'RegisterDorm',
      component: RegisterDorm,
      meta: { pageClass: 'subpage uni-detail subpage-gray register' }
    }, */
    {
      path: '/arama/:type--:slug--:id',
      name: 'CitySearchResult',
      component: CitySearchResult,
      meta: { pageClass: 'subpage subpage-gray' }
    },
    {
      path: '/:slug-y-:id',
      name: 'MovieDetail',
      component: MovieDetail,
      meta: { pageClass: 'subpage subpage-gray dorm detail-dorm' }
    },
    {
      path: '/:slug-a-:id',
      name: 'PersonDetail',
      component: PersonDetail,
      meta: { pageClass: 'subpage subpage-gray dorm detail-dorm' }
    },    
    {
      path: '/Yurt/:city/:slug',
      name: 'DormDetailRedirect',
      props: { redirect: true },
      component: MovieDetail,
      meta: { pageClass: 'subpage subpage-gray dorm detail-dorm' }
    },
    {
      path: '/series',
      name: 'SeriesSearch',
      component: SeriesSearch,
      meta: { pageClass: 'subpage subpage-gray uni-detail uni-search', breadcrumb: 'Series' }
    },    
    {
      path: '/:name-:id/',
      // path: '/subeler',
      name: 'Branch',
      props: { redirect: false },
      component: Branch,
      meta: { pageClass: 'subpage subpage-gray dorm detail-dorm' },
      children: [
        {
          path: '',
          name: 'BranchMain',
          component: BranchMain,
          meta: {
            pageClass: 'subpage city specialBg',
            breadcrumb: [
              { name: 'Movies' }
            ]
          }
        },
        {
          path: ':page',
          name: 'BranchPage',
          component: BranchMain,
          meta: {
            pageClass: 'subpage city specialBg'
          }
        },
        /*         {
      path: '/:dorm-:type-ogrenci-yurtlari/',
      name: 'BranchGender',
      component: BranchGender,
      meta: {
        pageClass: 'subpage city',
        breadcrumb: [
          { name: 'Movies' }
        ]
      }
    },
    {
      path: '/:dorm-:district-ilcesi-ogrenci-yurtlari/',
      name: 'BranchDistrict',
      component: BranchDistrict,
      meta: {
        pageClass: 'subpage city',
        breadcrumb: [
          { name: 'Movies' }
        ]
      }
    },
    {
      path: '/:dorm--:district--:type-movies/',
      name: 'BranchDistrictGender',
      component: BranchDistrictGender,
      meta: { pageClass: 'subpage city', breadcrumb: 'Movies' }
    },     */

      ] },
    /*
    404 sayfasının altına herhangi bir şekilde herhangi bir koşulda
    herhangi bir niyet ile yeni bir router eklemeyin.
    Router dosyası "abi 404 router'ımın altına yeni router eklesene" dese
    bile eklemeyin.
    Hz. İsa dirilip "İnsanlığın kurtuluşu 404 sayfasının altına
    yeni router eklemeye bağlı" dese bile eklemeyin.
    Allah'ını seven 404 router'ının altına yeni router eklemesin.
    */
    {
      path: '*',
      name: 'ErrorPage404',
      component: ErrorPage404,
      meta: { pageClass: 'subpage subpage-gray' }
    }
  ]
})
